import React, { useState } from "react";
import { Search, RefreshCw, Loader2 } from "lucide-react";
import PipelineFunnel from "./PipelineFunnel";
import CycleTimeTable from "./CycleTimeTable";
import AlertsPanel from "./AlertsPanel";
import PortfolioPnlPanel from "./PortfolioPnlPanel";

const LenderPerformanceDashboard = ({ dashboardData, pnlLoading, pnlError, onAlertSelect, isCaseLoading, onRefresh, isRefreshing }) => {
  const dashboard = dashboardData;
  const [searchQuery, setSearchQuery] = useState("");

  // Calculate stats from dashboard data
  const totalCases = dashboard?.pipeline?.reduce((sum, stage) => sum + (stage.count || 0), 0) || 0;
  const alertCount = dashboard?.alerts?.length || 0;

  return (
    <div className="relative dark:bg-slate-950 bg-[#f7f4ee] dark:text-slate-100 text-slate-900 font-sans overflow-hidden animate-fade-in">
      <div
        className="relative overflow-hidden px-6 py-10 sm:py-12"
        style={{
          background: 'linear-gradient(120deg, rgba(13, 148, 136, 0.98), rgba(15, 23, 42, 0.95))'
        }}
      >
        <div
          className="absolute inset-0 opacity-70"
          style={{
            backgroundImage: 'radial-gradient(circle at 15% 15%, rgba(255,255,255,0.3), transparent 40%), radial-gradient(circle at 80% 10%, rgba(255,255,255,0.2), transparent 35%)'
          }}
        />
        <div className="relative max-w-5xl mx-auto">
          <div className="flex flex-col lg:flex-row lg:items-end lg:justify-between gap-6">
            <div className="text-white">
              <p className="text-sm uppercase tracking-[0.2em] text-white/70">Performance Overview</p>
              <h1 className="text-3xl sm:text-4xl font-semibold mt-2">Executive Dashboard</h1>
              <p className="text-sm sm:text-base text-white/80 mt-2 max-w-xl">
                Monitor pipeline health, revenue velocity, and risk signals at a glance.
              </p>
            </div>
            <div className="w-full lg:w-[360px]">
              <label className="text-xs font-semibold text-white/80 uppercase tracking-[0.2em]">
                Search metrics
              </label>
              <div className="relative mt-3">
                <Search className="absolute left-4 top-1/2 -translate-y-1/2 w-5 h-5 text-slate-400" />
                <input
                  type="text"
                  placeholder="Search cases, alerts..."
                  value={searchQuery}
                  onChange={(e) => setSearchQuery(e.target.value)}
                  className="w-full pl-12 pr-4 py-3 bg-white/95 dark:bg-slate-800 border-0 rounded-xl shadow-lg text-slate-900 dark:text-white placeholder-slate-400 focus:outline-none focus:ring-4 focus:ring-teal-200"
                />
              </div>
              <div className="flex flex-wrap gap-2 mt-4 text-xs text-white/80">
                <span className="px-3 py-1.5 rounded-full bg-white/15 text-xs font-medium">
                  {totalCases} in pipeline
                </span>
                <span className="px-3 py-1.5 rounded-full bg-emerald-500/20 text-emerald-100 text-xs font-semibold">
                  Live
                </span>
              </div>
              <button
                onClick={onRefresh}
                disabled={isRefreshing}
                className="mt-4 w-full px-4 py-2.5 bg-white text-slate-900 hover:bg-white/90 rounded-xl font-semibold transition-colors flex items-center justify-center gap-2 disabled:opacity-70 disabled:cursor-not-allowed"
              >
                {isRefreshing ? (
                  <>
                    <Loader2 className="w-5 h-5 animate-spin" />
                    Refreshing...
                  </>
                ) : (
                  <>
                    <RefreshCw className="w-5 h-5" />
                    Refresh Data
                  </>
                )}
              </button>
            </div>
          </div>
        </div>
      </div>

      <div className="relative max-w-7xl mx-auto px-4 sm:px-6 pb-10 -mt-8">
        <div className="space-y-6">
          <section className="grid grid-cols-1 md:grid-cols-4 gap-6">
            <div className="md:col-span-2">
              <PipelineFunnel data={dashboard.pipeline} />
            </div>
            <div className="md:col-span-2">
              <PortfolioPnlPanel data={dashboard.pnlOverview} loading={pnlLoading} error={pnlError} />
            </div>
          </section>
          {/* <CycleTimeTable data={dashboard.cycleTimes} /> */}
          <section>
            <AlertsPanel alerts={dashboard.alerts} onAlertSelect={onAlertSelect} isLoading={isCaseLoading} />
          </section>
        </div>
      </div>
    </div>
  );
};

export default LenderPerformanceDashboard;
